import { render } from "./CancellationFailure.vue?vue&type=template&id=3a6c77e2"
const script = {}

import exportComponent from "/Users/computerscience/Desktop/connect-dashboard/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__